import React, { useEffect } from "react";

const events = [
  "load",
  "mousemove",
  "mousedown",
  "click",
  "scroll",
  "keypress",
];

const ApplicationLogout = ({ children }) => {
  let timer;
  //const logOutTime = 300000;
  //const logOutTime = 14400000; // 4 hours
  const logOutTime = 28800000; // 8 HOURS
  const handleLogoutTimer = () => {
    timer = setTimeout(() => {
      resetTimer();
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
      logoutAction();
    }, logOutTime);
  };

  const resetTimer = () => {
    if (timer) clearTimeout(timer);
  };

  useEffect(() => {
    Object.values(events).forEach((item) => {
      window.addEventListener(item, () => {
        resetTimer();
        handleLogoutTimer();
      });
    });

    handleLogoutTimer(); // Initialize the timer when the component mounts

    return () => {
      Object.values(events).forEach((item) => {
        window.removeEventListener(item, resetTimer);
      });
    };
  }, []);

  const logoutAction = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.pathname = "/";
  };

  return children;
};

export default ApplicationLogout;
